import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBooleanGroupSubstract: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="boolean-group-substract"><path d="M8.75 8.75H2.75V21.25H15.25V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 2.75H21.25V15.25H8.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBooleanGroupSubstract;
